import indexEn from "./en-US/indexEn";

export default {
  ...indexEn,
};



// WEBPACK FOOTER //
// ./src/locales/lang/en-US.js